import * as State from 'components/desktop/_general/Input/SuggestionSearchInput/SuggestionSearchInputState';
import { useHandler } from 'hooks/useHandler';

export default function useSuggestionSearchInputState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			onBlur: rf.createNoArgReducer(State.onBlur),
			onChange: rf.createReducer(State.onChange),
			onFocus: rf.createReducer(State.onFocus),
			setSearchTerm: rf.createReducer(State.setSearchTerm),
			setSelectionIndex: rf.createReducer(State.setSelectionIndex),
			setShowSuggested: rf.createReducer(State.setShowSuggested),
		},
	};
}
